module.exports = __webpack_public_path__ + "static/img/img03.7919800.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/images/img03.png
// module id = Yz9c
// module chunks = 1